import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="border-y border-ink-line bg-ink-panel px-4 py-8" data-id="element-162" data-mp="3kqw5io0qf8hp">
      <div className="mx-auto max-w-4xl" data-id="element-163" data-mp="3fyw1ajdmptfb">
        <h2 className="text-center text-xl font-extrabold sm:text-3xl" data-id="element-164" data-mp="3fxkusbssu7ki">
          What Therapists Are Saying
        </h2>
        <p className="mt-1 text-center text-sm text-ink-text sm:text-base" data-id="element-165" data-mp="36yzgisud1epj">
          ⭐⭐⭐⭐⭐ 4.9/5 — Verified Therapist Reviews
        </p>

        <div className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-166" data-mp="31yuvcpiibvsz">
          {testimonials.map((testimonial, index) => <figure key={testimonial.name} className={`rounded-xl border border-ink-line bg-ink-bg p-4 ${index === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-167" data-mp="2x1utyrwlrh87" data-mpi={index}>
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-168" data-mp="v96jbxhmprie">
                {Array.from({
              length: 5
            }).map((_, star) => <StarIcon key={star} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-169" data-mp="qavbfsaw9r2t" data-mpi={star} />)}
              </div>
              <blockquote className="mt-1.5 text-xs leading-snug text-ink-text sm:text-sm" data-id="element-170" data-mp="h818fqfnqklj">
                “{testimonial.quote}”
              </blockquote>
              <figcaption className="mt-2" data-id="element-171" data-mp="78ttiyt9yhwb">
                <p className="font-display text-[13px] font-bold uppercase text-white sm:text-sm" data-id="element-172" data-mp="7a4xozqmtrny">
                  {testimonial.name}
                </p>
                <p className="text-[11px] text-gold sm:text-xs" data-id="element-173" data-mp="zxhc2mmn2t66">{testimonial.role}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}